import './styles/batch-jobs-view.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import classnames  from 'classnames'
import moment      from 'moment'
import { Icon }    from 'semantic-ui-react'

import api from '../redux/api'

function formatTime(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD h:mm:ss A')
}

function hasFeatureFlag({ featureFlags, featureFlag }) {
  return !featureFlag || (featureFlag && featureFlags.includes(featureFlag))
}

class GroupView extends React.Component {
  static propTypes = {
    group:      PropTypes.object.isRequired,
    history:    PropTypes.object.isRequired,
    onNavigate: PropTypes.func.isRequired,
  }

  renderItem = ({ title, message }) => {
    return (
      <div className="item">          
        <div className="mini-title">{ title }</div>
        <div className="mini-message">{ message }</div>
      </div>
    )
  }

  render() {
    const { sender, receiver, dataType, nextActionTime, jobs } = this.props.group

    return (
      <div className="group-view">
        <div className="group-header">
          <div className="origin">
            { this.renderItem({ title: 'Sender',    message: sender.name }) }
            { this.renderItem({ title: 'Receiver',  message: receiver.name }) }
            { this.renderItem({ title: 'Data Type', message: dataType.name }) }
          </div>
          <div className="time">
            <div className="time-header">Next Batch Time</div>
            <div className="time-value">{ formatTime(nextActionTime) }</div>
          </div>
        </div>
        <div className="job-list">
          {
            jobs.map((job) => {
              const onClick = (event) => {
                event.preventDefault()
                this.props.onNavigate()
                this.props.history.push(`/jobs/item/${job.id}`)
              }

              return (
                <div key={job.id} className="job">
                  <div className="job-title">Creation Time</div>
                  <div className="creation-time">{ formatTime(job.creationTimestamp) }</div>
                  <a href="/" onClick={onClick}>Open Job</a>
                </div>
              )
            }) 
          }
        </div>
      </div>
    )
  }
}

class BatchJobsView extends React.Component {  
  static propTypes = {
    history:      PropTypes.object.isRequired,
    featureFlags: PropTypes.array.isRequired,
  }

  state = {
    open:    false,
    groups:  null,
    loading: false,
    error:   null,
  }

  handleOpen = () => {
    this.setState({ open: true, loading: true, error: null }, () => {
      api.getPendingBatchJobs().then((result) => {
        const groups = result.reduce((acc, { job, nextActionTime }) => {
          const key = `${job.sender.id}:${job.receiver.id}:${job.dataType.id}`

          if (!acc[key]) {
            acc[key] = {
              sender:         job.sender,
              receiver:       job.receiver,
              dataType:       job.dataType,
              nextActionTime: nextActionTime,
              jobs:           [],
            }
          }

          acc[key].jobs.push(job)

          return acc
        }, {})

        this.setState({ groups, loading: false })
      }).catch((error) => {
        this.setState({ loading: false, error: error.message || error })
      })
    })
  }

  handleClose = () => {
    this.setState({ open: false }, () => {
      setTimeout(() => {
        this.setState({ groups: null })
      }, 500)
    })
  }

  render() {
    if (!hasFeatureFlag({ featureFlags: this.props.featureFlags, featureFlag: 'enableBatchDeliveries' })) {
      return null
    }

    const { history } = this.props
    const { open, groups, loading, error } = this.state

    const contentClass = classnames('content', { open })    

    let message

    if (loading) {
      message = 'Loading...'
    } else if (error) {
      message = `Error loading data: ${error}`
    } else if (!groups || Object.keys(groups).length === 0) {
      message = 'Currently there are no jobs staged for batching'
    }
    
    return (
      <div className="batch-jobs-view">
        <div className="batch-jobs-view-button" onClick={this.handleOpen}>
          <Icon name="bold" />
        </div>


        <div className={contentClass}>
          <div className="close-button" onClick={this.handleClose}>
            <Icon name="close" />
          </div>

          <div className="title">
            Jobs Scheduled For Batching
          </div>

          <div className="view-content">
            { message && <div className="message">{ message }</div> }

            {
              groups && !message && (
                <div className="groups">
                  { Object.keys(groups).map((groupKey) => <GroupView key={groupKey} group={groups[groupKey]} history={history} onNavigate={this.handleClose} />)  }
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps = (state) => ({
  featureFlags: state.features.featureFlags,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BatchJobsView)
